<script lang="ts">
  import OpenPosition from "./open-position/index.svelte";
  import HowToApply from "./how-to-apply/index.svelte";
  import OpenSource from "./open-source/index.svelte";
  import checkMobileDevice from "../common/is-mobile";

  const openSource: boolean = false;
  const isMobile = checkMobileDevice();
</script>

<div class="careers-content" class:mobile={isMobile}>
  <div class="open-position">
    <OpenPosition />
  </div>

  <div class="how-to-apply">
    <HowToApply />
  </div>

  {#if openSource}
    <div class="open-source">
      <OpenSource />
    </div>
  {/if}
</div>

<style lang="postcss">
  /* .job-board {
    @apply text-center mt-10 mx-auto;
    max-width: 700px;
  }

  .job-board .title {
    @apply font-bold mx-auto w-max;
    background: linear-gradient(90.76deg, #5f89ff 0%, #3bc7ff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    font-size: clamp(2rem, 1.25rem + 1.5vw, 2.5rem);
  }

  .job-board .description {
    @apply px-6 mt-2;
  } */

  .careers-content :global(.section-title) {
    @apply font-semibold text-dark-300 mx-auto;
    /* font-size: clamp(1.875rem, 1.25rem + 1.25vw, 2.25rem); */
    font-size: 30px;
  }

  .careers-content :global(.section-description) {
    @apply typo-paragraph-1 text-dark-50;
    /* font-size: clamp(0.8125rem, 0.5rem + 0.5vw, 0.9375rem); */
    font-size: 15px;
    line-height: 1.7;
  }

  .careers-content :global(.section-content) {
    @apply mx-auto;
    width: min(calc(100% - 20px), 720px);
  }

  .how-to-apply {
    @apply bg-light-50;
  }

  .mobile .how-to-apply {
    @apply px-4;
  }
</style>
